import { Component, OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-finishes',
  templateUrl: './finishes.component.html',
  styleUrls: [
    './facilities.component.scss',
    './finishes.component.scss'
  ]
})

export class FinishesComponent extends SeoAwareBaseComponent implements OnInit {
  public reasons: any[] = [];
  public reasons2: any[] = [];
  public reasons3: any[] = [];
  translateSubscription: Subscription = new Subscription();
  subscription: Subscription = new Subscription();

  constructor(
    public injector: Injector,
    public translateService: TranslateService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.reasons = this.getReasons();
    this.reasons2 = this.getReasons2();
    this.reasons3 = this.getReasons3();

    this.subscription.add(this.translateService.onLangChange
      .subscribe(() => {
        this.reasons = this.getReasons();
        this.reasons2 = this.getReasons2();
        this.reasons3 = this.getReasons3();
      })
    );

    this.setTitle('Detalii proiect Romanescu Park Residence');

    this.setMetaDescription(`
      Romanescu Park Residence va cuprinde 4 faze de dezvoltare, clădirile având un regim de
      înălțime de tipul parter + 4 etaje. Cele 4 clădiri ce fac parte din prima fază a proiectului au
      denumiri specifice arborilor prezenți în Parcul Nicolae Romanescu: Stejar, Frasin, Tei, Arțar
    `);
  }

  getReasons(): any {
    const reasons = [];

    for (let i = 0; i < 4; i++) {
      const reason = {
        title: '',
        content: '',
        image: {
          url: ''
        }
      };

      this.translateSubscription.add(
        this.translateService.get('pages.downtown_life.finishes.phases.' + i + '.title')
          .subscribe((translatedString: string) => {
            reason.title = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('pages.downtown_life.finishes.phases.' + i + '.icon_url')
          .subscribe((translatedString: string) => {
            reason.image.url = translatedString;
          })
      );

      reasons.push(reason);
    }

    return reasons;
  }

  getReasons2(): any {
    const reasons2 = [];

    for (let i = 0; i < 4; i++) {
      const reason = {
        title: '',
        content: '',
        image: {
          url: ''
        }
      };

      this.translateSubscription.add(
        this.translateService.get('pages.downtown_life.finishes.phases2.' + i + '.title')
          .subscribe((translatedString: string) => {
            reason.title = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('pages.downtown_life.finishes.phases2.' + i + '.icon_url')
          .subscribe((translatedString: string) => {
            reason.image.url = translatedString;
          })
      );

      reasons2.push(reason);
    }

    return reasons2;
  }

  getReasons3(): any {
    const reasons3 = [];

    for (let i = 0; i < 3; i++) {
      const reason = {
        title: '',
        content: '',
        image: {
          url: ''
        }
      };

      this.translateSubscription.add(
        this.translateService.get('pages.downtown_life.finishes.phases3.' + i + '.title')
          .subscribe((translatedString: string) => {
            reason.title = translatedString;
          })
      );

      this.translateSubscription.add(
        this.translateService.get('pages.downtown_life.finishes.phases3.' + i + '.icon_url')
          .subscribe((translatedString: string) => {
            reason.image.url = translatedString;
          })
      );

      reasons3.push(reason);
    }

    return reasons3;
  }
}



// WEBPACK FOOTER //
// ./src/app/downtown-life/finishes.component.ts